<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-skeleton-loader v-if="$store.state.banks.retrieveLoader" transition="fade-transition" type="table" />
      <template v-else>
        <v-col v-if="!list.length" class="text-center py-5">
          <v-icon class="d-block" color="secondary" size="70">mdi-bank</v-icon>
          <span class="d-block subtitle-1">No tienes movimientos en la cuenta</span>
        </v-col>
        <template v-else>
          <v-data-table :headers="headers" :items="list" :items-per-page="pagination" hide-default-header disable-sort mobile-breakpoint hide-default-footer @click:row="(list) => {selectedTransfer = list, dialogArchiveTransfer = true}" style="cursor: pointer">
            <!-- header -->
            <template v-slot:[`header`]="{ props: { headers } }">
              <VTableHeaders :headers="headers" @sort="setSort" />
            </template>
            <!-- end header -->
            <template v-slot:[`item.bank`]="{item}">
              <img :src="require(`@/assets/appAsset-bankingLogo__${item.bank_name}_Min.svg`)" :alt="`${item.bank_name} bank brand`" width="24">
            </template>
            <template v-slot:[`item.description`]="{item}">
              <span>{{item.description}}</span>
            </template>
            <template v-slot:[`item.status`]="{item}">
              <div class="text-right">
                <v-chip v-if="item.status === 'finalized'" color="lightBlue" text-color="primary" small>Conciliado <v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                <v-chip v-else-if="item.status === 'archived'" color="defaultGrey" text-color="secondary" small>Archivado</v-chip>
                <v-chip v-else-if="item.status === 'pending'" color="defaultGrey" text-color="secondary" small>Pendiente</v-chip>
              </div>
            </template>
            <template v-slot:[`item.date`]="{item}">
              <span>{{item.date | dateTime}}</span>
            </template>
            <template v-slot:[`item.amount`]="{item}">
              <span class="body-2 text--secondary font-weight-medium">{{item.amount | currency(item.currency)}}</span> <span>{{item.currency}}</span>
            </template>
          </v-data-table>
          <template v-if="showPagination || showAll">
            <v-divider />
            <v-row class="mx-0" align="center">
              <template v-if="showPagination">
                <v-col cols="6">
                  <span class="body-2 text--secondary">{{count}} registros</span>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-pagination v-model="page" :length="totalPages" total-visible="6" />
                </v-col>
              </template>
            </v-row>
          </template>
        </template>
      </template>
    </v-col>

    <!-- dialog transfer -->
    <v-dialog v-model="dialogArchiveTransfer" width="700" persistent no-click-animation>
      <v-card>
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Detalle de transferencia</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="pr-1">
              <v-btn @click="dialogArchiveTransfer=false" icon small retain-focus-on-click><v-icon small>mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <!-- resume -->
          <v-row class="mx-0 white" align="center">
            <v-col cols="3">
              <span class="d-block mb-1">Monto</span>
              <span class="body-1 font-weight-medium mr-1">{{selectedTransfer.amount | currency(selectedTransfer.currency)}} {{selectedTransfer.currency}}</span>
            </v-col>
            <v-divider class="my-2" vertical />
            <v-col cols="3">
              <span class="d-block mb-1">Fecha</span>
              <span class="body-1 font-weight-medium mr-1">{{selectedTransfer.date | date}}</span>
            </v-col>
            <v-divider class="my-2" vertical />
            <v-col cols="3">
              <span class="d-block mb-1">Estado</span>
              <v-chip v-if="selectedTransfer.status === 'pending'" color="defaultGrey" text-color="secondary" small>Pendiente</v-chip>
              <v-chip v-else-if="selectedTransfer.status === 'archived'" color="defaultGrey" text-color="secondary" small>Archivado</v-chip>
              <v-chip v-else-if="selectedTransfer.status === 'finalized'" color="lightBlue" text-color="primary" small>Conciliado</v-chip>
            </v-col>
            <template v-if="selectedTransfer.status === 'pending'">
              <v-divider class="my-2" vertical />
              <v-col cols="2" class="text-right">
                <v-btn @click="destroy(selectedTransfer)" outlined color="red darken-2" retain-focus-on-click dark>Archivar</v-btn>
              </v-col>
            </template>
          </v-row>
          <v-divider />
          <!-- end resume -->
          <v-list class="v-list-form py-5 transparent">
            <v-list-item v-if="selectedTransfer.number">
              <v-list-item-title>Banco</v-list-item-title>
              <v-list-item-subtitle>{{selectedTransfer.bank_name}}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-if="selectedTransfer.number">
              <v-list-item-title>Identificador banco</v-list-item-title>
              <v-list-item-subtitle>{{selectedTransfer.number}}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Descripción</v-list-item-title>
              <v-list-item-subtitle>{{selectedTransfer.description}}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-if="selectedTransfer.origin_holder_name">
              <v-list-item-title>Nombre del titular</v-list-item-title>
              <v-list-item-subtitle>{{selectedTransfer.origin_holder_name}}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-if="selectedTransfer.origin_holder_id">
              <v-list-item-title>ID del titular</v-list-item-title>
              <v-list-item-subtitle>{{selectedTransfer.origin_holder_id}}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-if="selectedTransfer.origin_number">
              <v-list-item-title>ID Banco</v-list-item-title>
              <v-list-item-subtitle>{{selectedTransfer.origin_number}}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-if="selectedTransfer.status !== 'draft'">
              <v-list-item-title>Creado el</v-list-item-title>
              <v-list-item-subtitle>{{selectedTransfer.date | dateTime}}</v-list-item-subtitle>
            </v-list-item>
          </v-list>
          <template v-if="selectedTransfer.status === 'finalized'">
            <v-toolbar class="transparent" flat height="55">
              <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Pagos asociados</v-toolbar-title>
            </v-toolbar>
            <v-skeleton-loader v-if="$store.state.payments.retrieveLoader" class="mt-5" transition="fade-transition" type="list-item-avatar-three-line" />
            <v-row class="mx-0" v-else>
              <v-col cols="12">
                <v-alert class="my-0" border="left" colored-border color="darkBlue" elevation="1" icon="mdi-cash">
                  <v-row v-for="d in payments" :key="d.id" align="center" justify="center" no-gutters>
                    <v-col class="pa-0">
                      <span class="body-2 text--secondary">{{d.description}} por {{d.amount | currency(d.currency)}} {{d.currency}}</span>
                      <span class="body-2 d-block font-italic text--disabled">{{d.date | date}}</span>
                    </v-col>
                    <v-col class="pa-0 text-right">
                      <v-btn :to="{name: 'PaymentRetrieve', params: {id: d.id}}" height="20" text color="primary" retain-focus-on-click :ripple="false">Más información<v-icon right>mdi-arrow-right</v-icon></v-btn>
                    </v-col>
                  </v-row>
                </v-alert>
              </v-col>
            </v-row>
          </template>
          <template v-else-if="selectedTransfer.status === 'pending'">
            <v-toolbar class="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Asociar a un pago</v-toolbar-title>
            </v-toolbar>
            <v-row class="mx-0">
              <v-col cols="12">
                <v-text-field v-model="paymentQuery" background-color="white" outlined required single-line dense maxlength="60" hide-details placeholder="Escribe para buscar un pago..." />
                <span>Sólo se muestran pagos con un monto de <b>{{selectedTransfer.amount | currency(selectedTransfer.currency)}}</b> en moneda <b>{{selectedTransfer.currency}}</b></span>
              </v-col>
            </v-row>
            <v-divider />
            <v-skeleton-loader v-if="$store.state.payments.retrieveLoader" class="mt-5" transition="fade-transition" type="table" />
            <template v-else>
              <v-simple-table v-if="payments.length" dense>
                <template v-slot:default>
                  <tbody>
                    <tr v-for="d in payments" :key="d.id" @click="selectedPayment = d, authorizePayment()">
                      <td class="py-3">
                        <v-row align="center" justify="space-between">
                          <v-col>
                            <span class="body-1 text--secondary font-weight-medium">{{d.description}}</span>
                            <v-btn class="ml-1" :to="{name: 'CustomerRetrieveUpdate', params: {id: d.customer.id}}" v-if="d.customer" text color="primary">{{d.customer.name}}<v-icon small right>mdi-arrow-right</v-icon></v-btn>
                          </v-col>
                          <v-col class="text-right">
                            <span class="text--secondary font-weight-medium">{{d.amount | currency(d.currency)}}</span>
                            <span class="ml-1">{{d.currency}}</span>
                          </v-col>
                        </v-row>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-col class="text-center py-5" v-else>
                <v-icon color="secondary" size="70">mdi-close-circle</v-icon>
                <span class="d-block subtitle-1">No existen pagos</span>
              </v-col>
            </template>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end dialog transfer -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  components: {
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    dialogArchiveTransfer: false,
    headers: [
      { value: 'bank', sortable: true },
      { text: 'Descripción', value: 'description' },
      { value: 'status' },
      { text: 'Fecha', value: 'date', width: 300, align: 'end', sortable: true },
      { text: 'Monto', value: 'amount', width: 200, align: 'end', sortable: true }
    ],
    paymentQuery: '',
    selectedTransfer: {},
    selectedPayment: null
  }),
  computed: mapState({
    count: state => state.banks.ach_transfersCount,
    list: state => state.banks.ach_transfersList,
    payments: state => state.payments.paymentsList
  }),
  watch: {
    paymentQuery () {
      this.debounceMethod(this.getPaymentsFromQuery)
    },
    selectedTransfer () {
      if (this.selectedTransfer.status === 'finalized') {
        this.getPaymentsFromSelectedTransfer()
      } else if (this.selectedTransfer.status === 'pending') {
        this.getPayments()
      }
    }
  },
  methods: {
    destroy (instance) {
      if (instance.status === 'finalized') {
        return false
      }
      this.$dialog.warning({
        title: 'Archivar transferencia ACH',
        text: `
          <span class="d-block mb-4">Ya no podrás autorizar pagos con esta transferencia</span>
          <span class="d-block pl-6">¿Estás seguro de continuar?</span>
          <span class="d-block pl-6">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Archivar',
            handle: () => {
              this.$store.dispatch('banks/DESTROY', {
                resource: 'ach_transfers',
                id: instance.id
              })
              .then(() => {
                this.getList(false)
                this.dialogArchiveTransfer = false
                this.$dialog.message.info('La cuenta ha sido eliminada')
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    getPaymentsFromQuery () {
      if ([1, 2].includes(this.paymentQuery.length)) {
        return false
      }
      this.getPayments()
    },
    getPaymentsFromSelectedTransfer () {
      this.$store.dispatch('payments/LIST', {
        resource: 'payments',
        query: {
          source__id__in: this.selectedTransfer.sources.join(',')
        }
      })
    },
    getPayments () {
      const query = {
        status: 'requires_payment_method',
        amount: this.selectedTransfer.amount,
        currency: this.selectedTransfer.currency
      }
      if (this.paymentQuery.length >= 3) {
        query.description__icontains = this.paymentQuery.toLowerCase()
      }
      this.$store.dispatch('payments/LIST', {
        resource: 'payments',
        query: query
      })
    },
    authorizePayment () {
      this.$dialog.warning({
        title: 'Autorizar pago con transferencia ACH',
        text: `
          <span class="d-block mb-4">Al confirmar:</span>
          <span class="d-block pl-6">1. El estado del pago pasará a ser <b>pagado</b></span>
          <span class="d-block pl-6">2. El estado de la transferencia pasará a ser <b>conciliado</b></span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('payments/CREATE', {
                resource: 'sources',
                payload: {
                  ach_transfer: this.selectedTransfer.id,
                  gateway: 'ach_transfer',
                  usage: 'single'
                }
              })
              .then((response) => {
                this.selectedTransfer.sources = [response.data.id]
                this.selectedTransfer.status = 'finalized'
                this.$store.dispatch('payments/CREATE', {
                  resource: 'payments',
                  detail: 'authorize',
                  id: this.selectedPayment.id,
                  payload: {
                    source: response.data.id
                  }
                })
                .then((response) => {
                  this.getPaymentsFromSelectedTransfer()
                  this.$dialog.message.info('Pago autorizado con éxito.')
                })
                .catch((error) => {
                  this.$dialog.message.error(this.parseErrors(error.response.data))
                })
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    }
  }
}
</script>